export enum DefaultActionsView {
  List = 'list',
  Column = 'column',
}
